import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

type notice = {
    notice_no: number;
    notice_writer: string;
    notice_title: string;
    notice_time: string;
    notice_type: string;
}

type Data = notice[];

function Patch() {
    const [data, setData] = useState<Data>();

    useEffect(() => {
        const fetchData = async () => {
            const result = await fetch("api/get-patchnote");
            const notices = await result.json();
            console.log(notices);
            setData(notices.results);
        };
        fetchData();
    }, []);
    
  return (
    <div className='gl-post-box'>
        <div className='notice-box'>
            <h2>패치노트</h2>
        </div>
        <div className='table-box'>
            <ul>
              <hr></hr>
          {data ? (
            data.map((d) => (
              <li key={d.notice_no}>
                <p>
                  <Link to={`/post?notice_no=${d.notice_no}`}>
              <a className='table-title' style={{ textDecoration: "none"}}>{d.notice_title} </a>
              <a className='table-writer'>{d.notice_writer} </a>
              </Link>
              </p>
              </li>
            ))
          ) : (
            <></>
          )}
          <hr></hr>
        </ul>
    </div>
    </div>
  )
}

export default Patch;
